{
  "title": "Tableau de bord financier",
  "revenue_today": "Chiffre d'affaires du jour",
  "revenue_mtd": "CA mois en cours",
  "orders_today": "Commandes du jour",
  "avg_order_value": "Panier moyen",
  "vs_previous": "vs période précédente",
  "revenue_chart": "Évolution du chiffre d'affaires",
  "last_7_days": "7 derniers jours",
  "last_30_days": "30 derniers jours",
  "payment_breakdown": "Répartition par moyen de paiement",
  "wave": "Wave",
  "orange_money": "Orange Money",
  "cod": "Paiement à la livraison",
  "brand_revenue": "Chiffre d'affaires par marque",
  "brand": "Marque",
  "revenue": "Chiffre d'affaires",
  "orders": "Commandes",
  "avg_value": "Panier moyen",
  "top_product": "Produit phare",
  "tva_panel": "Récapitulatif TVA",
  "gross_revenue": "CA brut",
  "tva_rate": "Taux TVA",
  "tva_collected": "TVA collectée",
  "net_revenue": "CA net (hors TVA)",
  "period": "Période",
  "sage_export": "Export Sage",
  "sage_export_desc": "Générer un fichier compatible Sage",
  "download_csv": "Télécharger CSV",
  "period_daily": "Journalier",
  "period_weekly": "Hebdomadaire",
  "period_monthly": "Mensuel",
  "period_quarterly": "Trimestriel",
  "countre_dairy": "Countre Dairy",
  "yousra": "Yousra",
  "florida": "Florida",
  "kamax": "KamaX",
  "zone": "Zone",
  "no_data": "Aucune donnée disponible",
  "loading": "Chargement...",
  "export_generated": "Export généré avec succès",
  "fcfa": "FCFA"
}
